import React from 'react';
import { Spin as BaseSpin, SpinProps as BaseSpinProps } from 'antd';


export interface SpinProps extends BaseSpinProps { };

const Spin: React.FC<SpinProps> = ({ className, ...props }) => <BaseSpin {...props} className={className} />;

export default Spin;
